import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { extractAuthor } from "./util.js";
export function createHeaderExtended(registry, header, validators) {
  // an instance of the base extrinsic for us to extend
  var HeaderBase = registry.createClass('Header');

  var _author = /*#__PURE__*/new WeakMap();

  var _validators = /*#__PURE__*/new WeakMap();

  var Implementation = /*#__PURE__*/function (_HeaderBase) {
    _inherits(Implementation, _HeaderBase);

    var _super = _createSuper(Implementation);

    function Implementation(registry, header, validators) {
      var _this;

      _classCallCheck(this, Implementation);

      _this = _super.call(this, registry, header);

      _classPrivateFieldInitSpec(_assertThisInitialized(_this), _author, {
        writable: true,
        value: void 0
      });

      _classPrivateFieldInitSpec(_assertThisInitialized(_this), _validators, {
        writable: true,
        value: void 0
      });

      _classPrivateFieldSet(_assertThisInitialized(_this), _author, extractAuthor(_this.digest, validators));

      _classPrivateFieldSet(_assertThisInitialized(_this), _validators, validators);

      _this.createdAtHash = header === null || header === void 0 ? void 0 : header.createdAtHash;
      return _this;
    }
    /**
     * @description Convenience method, returns the author for the block
     */


    _createClass(Implementation, [{
      key: "author",
      get: function get() {
        return _classPrivateFieldGet(this, _author);
      }
      /**
       * @description Convenience method, returns the validators for the block
       */

    }, {
      key: "validators",
      get: function get() {
        return _classPrivateFieldGet(this, _validators);
      }
    }]);

    return Implementation;
  }(HeaderBase);

  return new Implementation(registry, header, validators);
}